import React, { useMemo } from "react";
import { IMAGE_URL } from "../../../path"; // ✅ import your image base URL

interface GalleryImage {
    id: number;
    file?: File | null;
    preview?: string; // relative or blob URL
}

interface Add4ImageGalleryProps {
    section: {
        id: number;
        images?: GalleryImage[];
    };
    onChange: (id: number, updatedData: Partial<any>) => void;
    onClose: () => void;
}

const Add4ImageGallery: React.FC<Add4ImageGalleryProps> = ({
                                                               section,
                                                               onChange,
                                                               onClose,
                                                           }) => {
    // ✅ Always have 4 slots, but reuse actual state reference
    const images: GalleryImage[] = useMemo(() => {
        const arr = Array.from({ length: 4 }, (_, i) => {
            const existing = section.images?.[i];
            return existing
                ? { ...existing, id: i }
                : { id: i, file: null, preview: "" };
        });
        return arr;
    }, [section.images]);

    // ✅ Update only one image, keep the rest
    const handleFileChange = (
        index: number,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        if (!e.target.files?.[0]) return;

        const file = e.target.files[0];
        const previewURL = URL.createObjectURL(file);

        const updatedImages = images.map((img, i) =>
            i === index ? { ...img, file, preview: previewURL } : img
        );

        onChange(section.id, { images: updatedImages });
    };

    return (
        <div
            style={{
                padding: "10px",
                position: "relative",
                marginBottom: "10px",
                border: "1px solid #ddd",
                borderRadius: "5px",
            }}
        >
            <button
                style={{
                    position: "absolute",
                    top: 5,
                    right: 5,
                    border: "none",
                    background: "none",
                    color: "black",
                    cursor: "pointer",
                }}
                onClick={onClose}
            >
                X
            </button>

            <h4 style={{ textAlign: "center", marginBottom: "10px" }}>
                4-Image Gallery
            </h4>

            <div
                style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    flexWrap: "wrap",
                }}
            >
                {images.map((img, index) => {
                    // ✅ Determine correct src:
                    // - If file exists, use blob URL
                    // - Else if preview starts with 'blob:' or 'data:', use directly
                    // - Else if it's a relative path, prepend IMAGE_URL
                    let src = "";
                    if (img.file) {
                        src = URL.createObjectURL(img.file);
                    } else if (img.preview) {
                        src =
                            img.preview.startsWith("blob:") ||
                            img.preview.startsWith("data:") ||
                            img.preview.startsWith("http")
                                ? img.preview
                                : `${IMAGE_URL}${img.preview}`;
                    }

                    return (
                        <div
                            key={index}
                            style={{
                                width: "22%",
                                border: "1px solid #ddd",
                                borderRadius: "5px",
                                padding: "8px",
                                textAlign: "center",
                                position: "relative",
                            }}
                        >
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleFileChange(index, e)}
                                className="form-control"
                                style={{ marginBottom: "5px" }}
                            />

                            {src && (
                                <img
                                    src={src}
                                    alt={`Preview ${index + 1}`}
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        borderRadius: "5px",
                                        marginTop: "5px",
                                    }}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Add4ImageGallery;
